import React from 'react';
import { type RichTextComponentProps } from 'content/RichText';
import RichTextBlock from 'libs/sanity/content/Blocks/RichTextBlock';
import styled from 'libs/styled';

interface RichTextModuleProps {
    data: {
        block: RichTextComponentProps;
    };
}

// Module-level vertical margin; horizontal padding; max-width/margin live on block (RichText)
const RichTextModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
    padding: 0 var(--grid-padding, 10px);
`;

const RichTextModule: React.FC<RichTextModuleProps> = (data) => {
    const { data: moduleData } = data;
    const blockData = moduleData?.block || moduleData;
    return (
        <RichTextModuleWrapper className="RichTextModule">
            <RichTextBlock data={blockData} />
        </RichTextModuleWrapper>
    );
};
export default RichTextModule;
